import Image from 'next/image';
import MoneyBack from '@image/icons/png-icons/product-page-assets/MoneyBack_256x256.png';
import Returns from '@image/icons/png-icons/product-page-assets/Returns_256x256.png';
import Shipping from '@image/icons/png-icons/product-page-assets/Shipping_256x256.png';
import Warranty from '@image/icons/png-icons/product-page-assets/Warranty_256x256.png';

export const ProductPageIconsForFreeShippingMoneyBackAndWarranty = () => {
  return <div className="flex justify-center lg:justify-between">
      <a
        target="_blank"
        href="https://help.skaraudio.com/category/6u4rvn8ul2-shipping"
        rel="noreferrer"
        aria-label="Shipping Help (opens in a new window)"
        aria-describedby="new-window-desc"
        className="mx-1">
        <Image
          src={Shipping}
          height={85}
          width={85}
          alt="Fast & Free Shipping"
        />
      </a>

      <a
        target="_blank"
        href="https://help.skaraudio.com/article/e4rc6qfws4-what-is-skar-audio-s-return-policy"
        rel="noreferrer"
        aria-label="Returns Help (opens in a new window)"
        aria-describedby="new-window-desc"
        className="mx-1">
        <Image
          src={Returns}
          height={85}
          width={85}
          alt="Hassle Free Returns"
        />
      </a>

      <a
        target="_blank"
        href="https://help.skaraudio.com/article/hoo5rcbt9h-returns-exchanges"
        rel="noreferrer"
        aria-label="Money Back Guarantee (opens in a new window)"
        aria-describedby="new-window-desc"
        className="mx-1"
      >
        <Image
          src={MoneyBack}
          alt="Money Back Guarantee"
          loading="lazy"
          decoding="async"
          height={85}
          width={85}
        />
      </a>

      <a
        target="_blank"
        href="/pages/warranty-policy"
        rel="noreferrer"
        aria-label="Warranty (opens in a new window)"
        aria-describedby="new-window-desc"
        className="mx-1">
        <Image
          src={Warranty}
          height={85}
          width={85}
          alt="2 Year Warranty"
        />
      </a>
    </div>
};
